module.exports = __webpack_public_path__ + "static/media/602d3941.jpg";